/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsBracketsCurly: {
  name: 'brackets-curly';
  data: string;
} = {
  name: 'brackets-curly',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g clip-path="url(#a)"><circle cx="5" cy="12" r="1" fill="currentColor"/><circle cx="8" cy="12" r="1" fill="currentColor"/><circle cx="11" cy="12" r="1" fill="currentColor"/><path d="M4 1H2v5L1 8l1 2v5h2M12 1h2v5l1 2-1 2v5h-2" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>`,
};
